import * as React from 'react'
import { DateRangePickerSeeker } from 'ui-seeker/core'

export default function DateRangePickerTravelerProfile({...props}) {

	const myProps = {
		...props
	}

    return <DateRangePickerSeeker {...myProps} />
}